import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import * as L from 'leaflet';

@Component({
    selector: 'app-gps-locator',
    templateUrl: './gps-locator.component.html',
    styleUrls: ['./gps-locator.component.css'],
    standalone: false
})
export class GpsLocatorComponent implements OnInit {

  map;
  mapLoaded: boolean = false;
  mapLoadedLoop;
  markers: L.Marker[] = [
    L.marker([41.66006733071602, 2.2319617198651565]) // RetSL HeadQuarters
  ];
  userLocationMarker: any = null;
  @Input() latitud: any = "";
  @Input() longitud: any = "";
  @Output() newLatitudEvent = new EventEmitter<string>();
  @Output() newLongitudEvent = new EventEmitter<string>();
  loadingBar: boolean = false;

  constructor() { }

  ngOnInit(): void {
    this.mapLoadedLoop = setInterval(() => {
      this.initMap();
    }, 500);
  }

  private initMap(): void {
    const mapContainer = document.getElementById('map');
    if(mapContainer){
      clearInterval(this.mapLoadedLoop);

      this.map = L.map(mapContainer, {
        center: [ 41.66006733071602, 2.2319617198651565 ],
        zoom: 7,
        dragging: false,
        zoomControl: false,
      });
  
      const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        minZoom: 3,
        attribution: ''
      });
      tiles.addTo(this.map);

      //this.markers.forEach(marker => marker.addTo(this.map));

      if(this.latitud !== "" && this.latitud !== ""){
        this.addmarkerMap(this.latitud, this.longitud);
        this.map.flyTo([this.latitud, this.longitud], 17);
      }else {
        this.locateUser();
      }

    }
  }

  locateUser() {
    this.loadingBar = true;
    this.latitud = "";
    this.longitud = "";
    if(this.userLocationMarker !== null) {
      this.map.removeLayer(this.userLocationMarker);
    }
    this.getCurrentPosition().subscribe((position: any) => {
      this.latitud = position.latitude;
      this.newLatitudEvent.emit(this.latitud);
      this.longitud = position.longitude;
      this.newLongitudEvent.emit(this.longitud);
      this.addmarkerMap(position.latitude, position.longitude);
      this.map.flyTo([position.latitude, position.longitude], 17);
      this.loadingBar = false;
    });
  }

  private getCurrentPosition(): any {
    return new Observable((observer: Subscriber<any>) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position: any) => {
          observer.next({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
          observer.complete();
        });
      } else {
        observer.error();
      }
    });
  }
 
  addmarkerMap(latitud: any, longitud: any){
    const icon = L.icon({
      iconUrl: 'assets/marker-icon.png',
      shadowUrl: 'assets/marker-shadow.png',
    });
    this.userLocationMarker = L.marker([latitud, longitud], { icon });
    this.userLocationMarker.addTo(this.map);
  }

}